import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";

//utils
import validatePhoneNumber from "../../utils/validatePhoneNumber";

//components
import AuthCard from "../../components/AuthCard/AuthCard";
import FormInput from "../../components/FormInput/FormInput";
import CustomButton from "../../components/CustomButton/CustomButton";
import ErrorAlert from "../../components/ErrorAlert/ErrorAlert";

import { sendResetPasswordEmail } from "../../services/auth";

const ResetPin = () => {
  const history = useHistory();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleError = (e) => {
    if (typeof e.response.data === "object")
      setError(e.response.data.non_field_errors[0]);
    else setError("An unexpected error occurred. Please try again later");
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const isPhoneNumberValid = validatePhoneNumber(phoneNumber);

    if (!isPhoneNumberValid) {
      setError("Invalid number");
      setLoading(false);
      return;
    }

    try {
      await sendResetPasswordEmail({ phone_number: phoneNumber });
      history.push(`/reset-pin/${phoneNumber}/verify-identity`);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  return (
    <AuthCard>
      <div className="flex flex-col items-center space-y-2">
        <h1 className="text-2xl font-bold text-center">Reset Pin</h1>

        <p className="leading-none text-center text-gray2 w-[60%] text-sm">
          Enter the phone number associated with your account and we'll send you
          a code to reset your PIN.
        </p>
      </div>

      <div className="w-[65%]">
        <form className="space-y-2" onSubmit={submit}>
          {error && <ErrorAlert error={error} />}
          <FormInput
            id="phoneNumber"
            name="phoneNumber"
            type="phoneNumber"
            placeholder="Phone Number"
            label="Phone Number"
            onChange={handleChange}
            value={phoneNumber}
            error={error}
          />
        </form>

        <CustomButton
          text="Continue"
          onClick={submit}
          disabled={phoneNumber === ""}
          loading={loading}
        />

        <div className="flex items-center justify-center mt-2">
          <Link
            to="/login"
            className="font-bold text-[12px] underline text-blue"
          >
            Return to login
          </Link>
        </div>

        <div className="flex items-center justify-center mt-3">
          <span className="text-[12px] text-gray-400">
            Don't have an account?{" "}
            <Link to="/login" className="font-bold underline text-blue">
              Sign up
            </Link>
          </span>
        </div>
      </div>
    </AuthCard>
  );
};

export default ResetPin;
